import { Button } from "~/common/components/Button/Button";
import classes from "./EmptyContractsScreen.module.less";
import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";
import type { ReactNode } from "react";
import {
  IMG_CONTRACTS_CALENDAR,
  IMG_CONTRACTS_CART,
  IMG_CONTRACTS_SPEED,
  IMG_CONTRACTS_USERS,
} from "~/utils/url/staticResources";
import { NEW_CONTRACT_PAGE } from "~/utils/url/staticUrls";
import { useTranslation } from "react-i18next";

interface EmptyContractsScreenProps {
  className?: string;
}

const BenefitsItem = ({ icon, title, text }: { icon: ReactNode; title: string; text: string }) => (
  <div className={classes.itemContainer}>
    {icon}
    <div className={classes.itemTextContainer}>
      <p className={classes.itemTitle}>{title}</p>
      <p>{text}</p>
    </div>
  </div>
);

const EmptyContractsScreen = ({ className }: EmptyContractsScreenProps) => {
  const { t } = useTranslation();
  return (
    <div className={classes.container}>
      <div className={classes.header}>{t("contractsList.empty")}</div>
      <Button
        href={NEW_CONTRACT_PAGE}
        className={classes.button}
        startIcon={<Icon type={IconType.Plus} />}
        clta-main-page-element-marker="request-new-contract-link"
      >
        {t("newContract.title")}
      </Button>
      <div className={classes.benefits}>
        <div className={classes.benefitsTitle}>{t("contractsList.benefitsTitle")}</div>
        <div className={classes.benefitsContent}>
          <BenefitsItem
            icon={<img src={IMG_CONTRACTS_CART} className={classes.benefitsIcon} />}
            title={t("contractsList.benefits.cart.title")}
            text={t("contractsList.benefits.cart.text")}
          />
          <BenefitsItem
            icon={<img src={IMG_CONTRACTS_CALENDAR} className={classes.benefitsIcon} />}
            title={t("contractsList.benefits.calendar.title")}
            text={t("contractsList.benefits.calendar.text")}
          />
          <BenefitsItem
            icon={<img src={IMG_CONTRACTS_SPEED} className={classes.benefitsIcon} />}
            title={t("contractsList.benefits.speed.title")}
            text={t("contractsList.benefits.speed.text")}
          />
          <BenefitsItem
            icon={<img src={IMG_CONTRACTS_USERS} className={classes.benefitsIcon} />}
            title={t("contractsList.benefits.users.title")}
            text={t("contractsList.benefits.users.text")}
          />
        </div>
      </div>
    </div>
  );
};

export default EmptyContractsScreen;
